module.exports = __webpack_public_path__ + "static/03_co-design workshop agenda.da752892.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/03_co-design workshop agenda.jpg
// module id = 477
// module chunks = 110568472390859